const items = ["Sound Healing", "Guided Yoga", "Mindfulness", "Renewal", "Breathwork", "Stillness"];

export const Marquee = () => (
  <div className="border-y border-line bg-surface py-6 overflow-hidden">
    <div className="flex w-max animate-marquee">
      {[...items, ...items].map((t, i) => (
        <div key={i} className="flex items-center">
          <span className="font-serif text-2xl sm:text-3xl tracking-wide text-forest px-8">{t}</span>
          <span className="text-clay">✦</span>
        </div>
      ))}
    </div>
  </div>
);
